import { Relationship } from "@/services/backend/relationships/types/relationship";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CompanySelect } from "@/services/backend/company/components/company-select";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";
import { BranchSelect } from "@/services/backend/company/components/branch-select";
import { CustomerSelect } from "@/services/backend/customers/components/customer-select";
import { ServiceObjectSelect } from "@/services/backend/customers/components/service-object-select";
import { DateInput } from "@/shared/components/form/date-input";

export function RelationshipCard({
  relationship,
}: {
  relationship: Relationship;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Beziehung")}</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-4">
        <div className="grid items-start gap-1.5">
          <Label>{t("Unternehmen")}</Label>
          <CompanySelect
            companyId={relationship.companyId}
            onCompanyIdChange={() => null}
            disabled
          />
        </div>
        <div className="grid items-start gap-1.5">
          <Label>{t("Niederlassung")}</Label>
          <BranchSelect
            value={relationship.branchId}
            onValueChange={() => null}
            companyId={relationship.companyId}
            disabled
          />
        </div>
        <div className="grid items-start gap-1.5">
          <Label>{t("Kunde")}</Label>
          <CustomerSelect
            value={relationship.customerId}
            onValueChange={() => null}
            disabled
          />
        </div>
        <div className="grid items-start gap-1.5">
          <Label>{t("Objekt")}</Label>
          <ServiceObjectSelect
            value={relationship.serviceObjectId}
            onValueChange={() => null}
            disabled
          />
        </div>
        <DateInput
          label={t("Start")}
          date={relationship.start}
          onDateChange={() => null}
          disabled
        />
        <DateInput
          label={t("Ende")}
          date={relationship.end}
          onDateChange={() => null}
          disabled
        />
      </CardContent>
    </Card>
  );
}
